export default {
  //
  MenuBackground: "#3a3a3a",
  MenuHoverBackground: "black",
  MenuFocusBackground: "#ff6833",
  MenuLine: "rgba(255, 255, 255, .09)",
  ContentBoxBackground: "#f1f0f0",
  HeaderBackground: "#FFFFFF",
  IconColor: "grey",
  PlusButtonBackground: "#f15a23",
  ModalBackground: "#3d3d3d",
  ModalText: "#a9a9a9",
  ModalScrollBackground: "#2c2c2c",
};
